import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { useCreateOrder } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";

import type { TopUpForm } from "./TopUpWrap";

const TopUpAmountModal = () => {
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useFormContext<TopUpForm>();

  const { closeModal, openModal } = useModalRouter();

  const { mutate: createOrder, isPending } = useCreateOrder();

  const amount = getValues("amount");

  const { t } = useTranslation();

  const onSubmit = (data: TopUpForm) => {
    createOrder(
      {
        order_type: "top_up",
        amount: +data.amount * 100,
        use_cashback: false,
        bank_card_id: "payment",
      },
      {
        onSuccess: (res) => {
          openModal(
            [MODAL_ROUTES.TOP_UP, MODAL_ROUTES.TOP_UP_METHODS],
            { tr_id: res.data.id.toString(), payment_type: "top-up" },
            true,
          );
        },
        onError,
      },
    );
  };

  return (
    <div className={"space-y-10 max-lg:!rounded-none md:w-[25rem]"}>
      <div className={"staff-modal__header"}>
        <h2 className={"staff-modal__title"}>{t("TopUp.title")}</h2>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="mb-2"
          errors={errors}
          name="amount"
          type={"currency"}
          control={control}
          value={amount}
          placeholder={t("TopUp.amount")}
          errorMessage={errors.amount?.message}
          validation={{
            required: { value: true, message: t("Form.required") },
            minLength: { value: 4, message: t("TopUp.min-require") },
          }}
        />
        <div className="mt-4 flex gap-3">
          <Button onClick={closeModal} className="w-[50%]" color="black">
            {t("Actions.cancel")}
          </Button>
          <Button className="w-[50%]" isLoading={isPending} type="submit">
            {t("Actions.continue")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default TopUpAmountModal;
